import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-fd8bdff0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "source"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode(" 开始评议 ");

var _hoisted_3 = {
  key: 0,
  class: "source"
};

var _hoisted_4 = /*#__PURE__*/_createTextVNode(" 查看评议 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_table = _resolveComponent("el-table");

  var _component_Pagination = _resolveComponent("Pagination");

  return _openBlock(), _createElementBlock("div", null, [_ctx.tabsIndex == 0 ? (_openBlock(), _createBlock(_component_el_table, {
    key: 0,
    "show-header": false,
    data: _ctx.tableData,
    style: {
      "width": "100%"
    },
    class: "el-table-index"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        label: "title",
        width: "300"
      }, {
        default: _withCtx(function (scoped) {
          return [_ctx.topTabsIndex == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(scoped.row.launchType == 2 ? _ctx.source : ""), 1)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(scoped.row.title), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "startTime",
        label: "startTime",
        width: "200"
      }), _createVNode(_component_el_table_column, {
        prop: "endTime",
        label: "endTime",
        width: "200"
      }), _createVNode(_component_el_table_column, {
        label: "Operations"
      }, {
        default: _withCtx(function (scope) {
          return [_withDirectives(_createVNode(_component_el_button, {
            type: "text",
            class: "btn_detail",
            onClick: function onClick($event) {
              return _ctx.handleDelete(scope.row);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 2
          }, 1032, ["onClick"]), [[_vShow, scope.row.title != '']])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data"])) : (_openBlock(), _createBlock(_component_el_table, {
    key: 1,
    "show-header": false,
    data: _ctx.tableData,
    style: {
      "width": "100%"
    },
    class: "el-table-index"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        label: "title",
        width: "380"
      }, {
        default: _withCtx(function (scoped) {
          return [_ctx.topTabsIndex == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(scoped.row.launchType == 2 ? _ctx.source : ""), 1)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(scoped.row.title), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "startTime",
        label: "startTime",
        width: "380"
      }), _createVNode(_component_el_table_column, {
        label: "Operations"
      }, {
        default: _withCtx(function (scope) {
          return [_withDirectives(_createVNode(_component_el_button, {
            type: "text",
            class: "btn_detail",
            onClick: function onClick($event) {
              return _ctx.hisoryDelete(scope.row);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_4];
            }),
            _: 2
          }, 1032, ["onClick"]), [[_vShow, _ctx.tableData[0].title != '']])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data"])), _createVNode(_component_Pagination, {
    pagesize: 10,
    "total-num": _ctx.totalNum,
    onChangPage: _ctx.changPage
  }, null, 8, ["total-num", "onChangPage"])]);
}